<div class="container-fluid d-flex p-0">
  <app-side-bar></app-side-bar>

  <!-- Header Block -->
  <div class="container-fluid">
    <div class="container-fluid my-3">
      <div class="top-card">
        <div class="row w-100 mx-auto d-flex">
          <div class="col-sm-12 col-md-12 col-lg-9 pl-4">
            <!-- <img class="logo-top" src="../../assets/images/logo-M (1).png" /> -->
            <span class="">Portfolio Management Suite</span>
          </div>
        </div>
      </div>
    </div>
    <div class="card" style="margin: 10px; border-radius: 10px">
      <div class="">
        <div class="row">
          <div class="col-2 col-md-2 col-sm-12" style="margin: 10px">
            <p class="my-auto ml-3" style="font-size: 20px; font-weight: 600">
              Enter The Molecule
            </p>
          </div>

          <div class="col-5 col-md-5 col-sm-12" style="margin: 10px">
            <i class="fa fa-search icon" style="margin-right: 10px"></i>
            <input class="w-75" placeholder="Enter the Molecule" [(ngModel)]="brandname"
              (keydown.enter)="searchMolecule1()" autofocus />
          </div>

          <div class="col-1 col-md-1 col-sm-12" style="margin: 10px">
            <button type="button" class="btn btn-light" (click)="searchMolecule1()">
              Submit
            </button>
          </div>
          <div class="col-2 col-md-2 col-sm-12" style="margin: 10px;">
            <p-dropdown [options]="submolecules" [(ngModel)]="selectedSubMolecule" autoWidth="false"
              [style]="{'width':'90%','font-size':'12px'}" optionLabel="name" placeholder="Select NDA"
              (click)="getData1()" *ngIf="subMolecule">
            </p-dropdown>
          </div>
          <div class="col-1 col-md-1 col-sm-12" style="margin: 10px">
            <button type="button" class="btn btn-light" (click)="clearFilter()">
              Clear
            </button>
            <button type="button" class="btn btn-light"
              (click)="saveAllMolecule(allMoleculeData['Approved ANDA filers'].value,allMoleculeData['Tentatively approved ANDAs'].value,allMoleculeData['Filed ANDA'].value,allMoleculeData['Expected ANDA Entrants'].value)">
              Save All
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- <div style="
    float: left;
">
      <button (click)="editbtn()" class="btn-success" style="
      padding: 5px;
  ">Edit</button>
    </div>
    <div *ngIf="showedit" class="text-center" style="
    margin-left: 10px;
    float: left;">
       <button class="btn btn-primary" (click)="saveMolecule()">Save</button> 
    </div> -->
    <table class="table table-striped table-bordered text-center" style="
    margin-left: 16px;
">
      <thead>
        <tr>
          <th scope="col" style="font-weight: bold">Name of Company</th>
          <th scope="col" style="font-weight: bold">Strength</th>
          <th scope="col" style="font-weight: bold">Approval Date</th>
          <th scope="col" style="font-weight: bold">Expected Launch Date</th>
          <th scope="col" style="font-weight: bold">180 Day Exclusivity</th>
          <th scope="col" style="font-weight: bold">Current Market Shares(%)</th>
          <th scope="col" style="font-weight: bold">Probable API Source</th>
          <th scope="col" style="font-weight: bold">Comment (If any)</th>
        </tr>
      </thead>
      <tbody>
        <ng-container *ngIf="Molecule">
          <tr *ngFor="let aNda of allMoleculeData['Approved ANDA filers'].value;">
            <td>
              <p *ngIf="showedit == true">
                <input type="text" (change)="editdata($event,company,'company',index)" id={{companyName}}
                  [(ngModel)]="aNda ['company_name']" />
              </p>
              <p *ngIf="showedit == false">
                {{ aNda ['company_name'] || '-'}}
              </p>
            </td>
            <td>
              <p *ngIf="showedit == true">
                <input type="text" (change)="editdata($event,company,'company',index)" id={{Strength}}
                  [(ngModel)]="aNda ['Strength']" />
              </p>
              <p *ngIf="showedit == false">
                {{ aNda ['Strength'] || '-'}}
              </p>
            </td>
            <td>
              <p *ngIf="showedit == true">
                <input type="text" (change)="editdata($event,company,'company',index)" id={{ApprovalDate}}
                  [(ngModel)]="aNda ['Approval Date']" />
              </p>
              <p *ngIf="showedit == false">
                {{ aNda ['Approval Date'] || '-'}}
              </p>
            </td>
            <td>
              <p *ngIf="showedit == true">
                <input type="text" (change)="editdata($event,company,'company',index)" id={{Expected_launch_date}}
                  [(ngModel)]="aNda ['Expected_launch_date']" />
              </p>
              <p *ngIf="showedit == false">
                {{ aNda ['Expected_launch_date'] || '-'}}
              </p>
            </td>
            <td>
              <p *ngIf="showedit == true">
                <input type="text" (change)="editdata($event,company,'company',index)" id={{one_eighty_day_exciusivity}}
                  [(ngModel)]="aNda ['one_eighty_day_exciusivity']" />
              </p>
              <p *ngIf="showedit == false">
                {{ aNda ['one_eighty_day_exciusivity'] || '-'}}
              </p>
            </td>
            <td>
              <p *ngIf="showedit == true">
                <input type="text" (change)="editdata($event,company,'company',index)" id={{current_market_shares}}
                  [(ngModel)]="aNda['current_market_shares']" />
              </p>
              <p *ngIf="showedit == false">
                {{ aNda['current_market_shares'] || '-'}}
              </p>
            </td>
            <td>
              <p *ngIf="showedit == true">
                <input type="text" (change)="editdata($event,company,'company',index)" id={{Probable_API_source}}
                  [(ngModel)]="aNda['Probable_API_source']" />
              </p>
              <p *ngIf="showedit == false">
                {{ aNda['Probable_API_source'] || '-'}}
              </p>
            </td>
            <td>
              <p *ngIf="showedit == true">
                <input type="text" (change)="editdata($event,company,'company',index)" id={{comment_if_any}}
                  [(ngModel)]="aNda['comment_if_any']" />
              </p>
              <p *ngIf="showedit == false">
                {{ aNda['comment_if_any'] || '-'}}
              </p>
            </td>
            <td>
              <button (click)="editbtn()" class="btn-success" style="
    padding: 5px;
">Edit</button>
              <button class="btn btn-primary" *ngIf="showedit" (click)="saveMolecule(aNda)"
                style="margin-top: 5px;">Save</button>
            </td>
          </tr>
          <tr *ngFor="let tNda of  allMoleculeData['Tentatively approved ANDAs'].value;">
            <td>
              <p *ngIf="showedit == true">
                <input type="text" (change)="editdata($event,company,'company',index)" id={{companyName}}
                  [(ngModel)]="tNda ['company_name']" />
              </p>
              <p *ngIf="showedit == false">
                {{ tNda ['company_name'] || '-' }}
              </p>
            </td>
            <td>
              <p *ngIf="showedit == true">
                <input type="text" (change)="editdata($event,company,'company',index)" id={{Strength}}
                  [(ngModel)]="tNda ['Strength']" />
              </p>
              <p *ngIf="showedit == false">
                {{ tNda ['Strength'] || '-'}}
              </p>
            </td>
            <td>
              <p *ngIf="showedit == true">
                <input type="text" (change)="editdata($event,company,'company',index)" id={{TentativeApprovalDate}}
                  [(ngModel)]="tNda ['Tentative Approval Date']" />
              </p>
              <p *ngIf="showedit == false">
                {{ tNda ['Tentative Approval Date'] || '-'}}
              </p>
            </td>
            <td>
              <p *ngIf="showedit == true">
                <input type="text" (change)="editdata($event,company,'company',index)" id={{Expected_launch_date}}
                  [(ngModel)]="tNda ['Expected_launch_date']" />
              </p>
              <p *ngIf="showedit == false">
                {{ tNda['Expected_launch_date'] || '-'}}
              </p>
            </td>
            <td>
              <p *ngIf="showedit == true">
                <input type="text" (change)="editdata($event,company,'company',index)" id={{one_eighty_day_exciusivity}}
                  [(ngModel)]="tNda['one_eighty_day_exciusivity']" />
              </p>
              <p *ngIf="showedit == false">
                {{ tNda['one_eighty_day_exciusivity'] || '-'}}
              </p>
            </td>
            <td>
              <p *ngIf="showedit == true">
                <input type="text" (change)="editdata($event,company,'company',index)" id={{current_market_shares}}
                  [(ngModel)]="tNda['current_market_shares']" />
              </p>
              <p *ngIf="showedit == false">
                {{ tNda['current_market_shares'] || '-'}}
              </p>
            </td>
            <td>
              <p *ngIf="showedit == true">
                <input type="text" (change)="editdata($event,company,'company',index)" id={{Probable_API_source}}
                  [(ngModel)]="tNda['Probable_API_source']" />
              </p>
              <p *ngIf="showedit == false">
                {{ tNda['Probable_API_source'] || '-'}}
              </p>
            </td>
            <td>
              <p *ngIf="showedit == true">
                <input type="text" (change)="editdata($event,company,'company',index)" id={{comment_if_any}}
                  [(ngModel)]="tNda['comment_if_any']" />
              </p>
              <p *ngIf="showedit == false">
                {{ tNda['comment_if_any'] || '-'}}
              </p>
            </td>
            <td>
              <button (click)="editbtn()" class="btn-success" style="
      padding: 5px;
  ">Edit</button>
              <button class="btn btn-primary" *ngIf="showedit" (click)="saveMolecule(tNda)"
                style="margin-top: 5px;">Save</button>
            </td>
          </tr>
          <tr *ngFor="let fNDa of  allMoleculeData['Filed ANDA'].value;">
            <td>
              <p *ngIf="showedit == true">
                <input type="text" (change)="editdata($event,company,'company',index)" id={{companyName}}
                  [(ngModel)]="fNDa ['company_name']" />
              </p>
              <p *ngIf="showedit == false">
                {{ fNDa ['company_name'] || '-' }}
              </p>
            </td>
            <td>
              <p *ngIf="showedit == true">
                <input type="text" (change)="editdata($event,company,'company',index)" id={{Strength}}
                  [(ngModel)]="fNDa ['Strength']" />
              </p>
              <p *ngIf="showedit == false">
                {{ fNDa ['Strength'] || '-'}}
              </p>
            </td>
            <td>
              <p *ngIf="showedit == true">
                <input type="text" (change)="editdata($event,company,'company',index)" id={{TentativeApprovalDate}}
                  [(ngModel)]="fNDa ['Approval Date']" />
              </p>
              <p *ngIf="showedit == false">
                {{ fNDa ['Approval Date'] || '-'}}
              </p>
            </td>
            <td>
              <p *ngIf="showedit == true">
                <input type="text" (change)="editdata($event,company,'company',index)" id={{Expected_launch_date}}
                  [(ngModel)]="fNDa ['Expected_launch_date']" />
              </p>
              <p *ngIf="showedit == false">
                {{ fNDa['Expected_launch_date'] || '-'}}
              </p>
            </td>
            <td>
              <p *ngIf="showedit == true">
                <input type="text" (change)="editdata($event,company,'company',index)" id={{one_eighty_day_exciusivity}}
                  [(ngModel)]="fNDa['one_eighty_day_exciusivity']" />
              </p>
              <p *ngIf="showedit == false">
                {{ fNDa['one_eighty_day_exciusivity'] || '-'}}
              </p>
            </td>
            <td>
              <p *ngIf="showedit == true">
                <input type="text" (change)="editdata($event,company,'company',index)" id={{current_market_shares}}
                  [(ngModel)]="fNDa['current_market_shares']" />
              </p>
              <p *ngIf="showedit == false">
                {{ fNDa['current_market_shares'] || '-'}}
              </p>
            </td>
            <td>
              <p *ngIf="showedit == true">
                <input type="text" (change)="editdata($event,company,'company',index)" id={{Probable_API_source}}
                  [(ngModel)]="fNDa['Probable_API_source']" />
              </p>
              <p *ngIf="showedit == false">
                {{ fNDa['Probable_API_source'] || '-'}}
              </p>
            </td>
            <td>
              <p *ngIf="showedit == true">
                <input type="text" (change)="editdata($event,company,'company',index)" id={{comment_if_any}}
                  [(ngModel)]="fNDa['comment_if_any']" />
              </p>
              <p *ngIf="showedit == false">
                {{ fNDa['comment_if_any'] || '-'}}
              </p>
            </td>
            <td>
              <button (click)="editbtn()" class="btn-success" style="
      padding: 5px;
  ">Edit</button>
              <button class="btn btn-primary" *ngIf="showedit" (click)="saveMolecule(fNDa)"
                style="margin-top: 5px;">Save</button>
            </td>
          </tr>
          <tr *ngFor="let eNda of allMoleculeData['Expected ANDA Entrants'].value;">
            <td>
              <p *ngIf="showedit == true">
                <input type="text" (change)="editdata($event,company,'company',index)" id={{company_name}}
                  [(ngModel)]="eNda['company_name']" />
              </p>
              <p *ngIf="showedit == false">
                {{ eNda ['company_name'] || '-'}}
              </p>
            </td>
            <td>
              <p *ngIf="showedit == true">
                <input type="text" (change)="editdata($event,company,'company',index)" id={{Strength}}
                  [(ngModel)]="eNda['Strength']" />
              </p>
              <p *ngIf="showedit == false">
                {{ eNda ['Strength'] || '-'}}
              </p>
            </td>
            <td>
              <p *ngIf="showedit == true">
                <input type="text" (change)="editdata($event,company,'company',index)" id={{ApprovalDate}}
                  [(ngModel)]="eNda['Approval Date']" />
              </p>
              <p *ngIf="showedit == false">
                {{ eNda ['Approval Date'] || '-'}}
              </p>
            </td>
            <td>
              <p *ngIf="showedit == true">
                <input type="text" (change)="editdata($event,company,'company',index)" id={{Expectedlaunchdate}}
                  [(ngModel)]="eNda['Expected_launch_date']" />
              </p>
              <p *ngIf="showedit == false">
                {{ eNda ['Expected_launch_date'] || '-'}}
              </p>
            </td>
            <td>
              <p *ngIf="showedit == true">
                <input type="text" (change)="editdata($event,company,'company',index)" id={{oneeightydayexciusivity}}
                  [(ngModel)]="eNda['one_eighty_day_exciusivity']" />
              </p>
              <p *ngIf="showedit == false">
                {{ eNda ['one_eighty_day_exciusivity'] || '-'}}
              </p>
            </td>
            <td>
              <p *ngIf="showedit == true">
                <input type="text" (change)="editdata($event,company,'company',index)" id={{currentmarketshares}}
                  [(ngModel)]="eNda['current_market_shares']" />
              </p>
              <p *ngIf="showedit == false">
                {{ eNda ['current_market_shares'] || '-'}}
              </p>
            </td>
            <td>
              <p *ngIf="showedit == true">
                <input type="text" (change)="editdata($event,company,'company',index)" id={{ProbableAPIsource}}
                  [(ngModel)]="eNda['Probable_API_source']" />
              </p>
              <p *ngIf="showedit == false">
                {{ eNda['Probable_API_source'] || '-'}}
              </p>
            </td>
            <td>
              <p *ngIf="showedit == true">
                <input type="text" (change)="editdata($event,company,'company',index)" id={{commentifany}}
                  [(ngModel)]="eNda['comment_if_any']" />
              </p>
              <p *ngIf="showedit == false">
                {{ eNda['comment_if_any'] || '-'}}
              </p>
            </td>
            <td>
              <button (click)="editbtn()" class="btn-success" style="
    padding: 5px;
">Edit</button>
              <button class="btn btn-primary" *ngIf="showedit" (click)="saveMolecule(eNda)"
                style="margin-top: 5px;">Save</button>
            </td>
          </tr>
        </ng-container>
      </tbody>
    </table>

    <!-- Removed Entries Table -->
    <div
      *ngIf="Molecule && allMoleculeData && allMoleculeData['removed_entries'] && allMoleculeData['removed_entries'].length > 0"
      class="my-4">
      <h3 style="margin-left: 16px; font-weight: bold; color: #8a2e72; margin-top: 30px; margin-bottom: 15px;">Removed
        Entries</h3>
      <table class="table table-striped table-bordered text-center" style="margin-left: 16px;">
        <thead>
          <tr>
            <th scope="col" style="font-weight: bold">Name of Company</th>
            <th scope="col" style="font-weight: bold">Strength</th>
            <th scope="col" style="font-weight: bold">Approval Date</th>
            <th scope="col" style="font-weight: bold">Expected Launch Date</th>
            <th scope="col" style="font-weight: bold">180 Day Exclusivity</th>
            <th scope="col" style="font-weight: bold">Current Market Shares(%)</th>
            <th scope="col" style="font-weight: bold">Probable API Source</th>
            <th scope="col" style="font-weight: bold">Comment (If any)</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of allMoleculeData['removed_entries']">
            <td>{{ item.data ? (item.data['company_name'] || '-') : '-' }}</td>
            <td>{{ item.data ? (item.data['Strength'] || '-') : '-' }}</td>
            <td>{{ item.data ? (item.data['Approval Date'] || item.data['Tentative Approval Date'] || '-') : '-' }}</td>
            <td>{{ item.data ? (item.data['Expected_launch_date'] || '-') : '-' }}</td>
            <td>{{ item.data ? (item.data['one_eighty_day_exclusivity'] || item.data['one_eighty_day_exciusivity'] ||
              '-') : '-' }}</td>
            <td>{{ item.data ? (item.data['current_market_shares'] || '-') : '-' }}</td>
            <td>{{ item.data ? (item.data['Probable_API_source'] || '-') : '-' }}</td>
            <td>{{ item.data ? (item.data['comment_if_any'] || '-') : '-' }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>